var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevOpsControl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DevOpsControlforHCL",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8vzwzwo4la",
    x1: 20.661,
    y1: 9.726,
    x2: 23.009,
    y2: 3.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aqnhj3p2hb",
    x1: -75.469,
    y1: 3717.142,
    x2: -72.471,
    y2: 3710.712,
    gradientTransform: "rotate(-180 -31.947 1869.724)",
    xlinkHref: "#8vzwzwo4la"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "077zg1ezlc",
    x1: 52.636,
    y1: 3717.142,
    x2: 55.634,
    y2: 3710.712,
    gradientTransform: "matrix(1 0 0 -1 -32.211 3739.447)",
    xlinkHref: "#8vzwzwo4la"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "49lsslyasd",
    x1: -75.575,
    y1: 9.695,
    x2: -72.577,
    y2: 3.265,
    gradientTransform: "matrix(-1 0 0 1 -63.895 0)",
    xlinkHref: "#8vzwzwo4la"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "sfyykd2i6f",
    x1: -5378,
    y1: -3192,
    x2: -5346,
    y2: -3224,
    gradientTransform: "translate(5378 3224)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#9e6efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0f62f7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "5txubfscxe",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.895 9.447-1.789-.895 1.724-3.447A1.986 1.986 0 0 1 21.619 4h3.382v2h-3.382l-1.724 3.447z",
    style: {
      fill: "url(#8vzwzwo4la)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 8c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.105 22.553 1.789.895-1.724 3.447A1.986 1.986 0 0 1 10.381 28H6.999v-2h3.382l1.724-3.447z",
    style: {
      fill: "url(#aqnhj3p2hb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 24c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.895 22.553-1.789.895 1.724 3.447A1.986 1.986 0 0 0 21.619 28h3.382v-2h-3.382l-1.724-3.447z",
    style: {
      fill: "url(#077zg1ezlc)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 27c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.211 9.447 14 8.552l-1.724-3.447A1.986 1.986 0 0 0 10.487 4H7.105v2h3.382l1.724 3.447z",
    style: {
      fill: "url(#49lsslyasd)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3zm2 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#5txubfscxe)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0V0z",
    style: {
      fill: "url(#sfyykd2i6f)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 10c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6 2.692-6 6-6m0-2a8 8 0 1 0 0 16 8 8 0 0 0 0-16z",
    style: {
      fill: "#001d6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001d6c"
    },
    d: "m15.005 16.178-1.561-1.622L12 16l3 3 5-5-1.41-1.443-3.585 3.621z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsControl);
export default __webpack_public_path__ + "static/media/DevOpsControl.d7c791e93f6ed8268b205160c10358af.svg";
export { ForwardRef as ReactComponent };